var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-dim flex-col"},[_c('div',{staticClass:"safe-area absolute"},[_c('div',{staticClass:"popup-wrap"},[_c('div',[_c('span',[_vm._v(_vm._s(_vm.registData.retMsg))])])]),_c('div',{on:{"click":_vm.closeRegistrationPopup}},[_c('bottom-button',{attrs:{"buttonArray":_vm.buttonArray}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }